export default __webpack_public_path__ + "static/media/microsoft-excel-seeklogo.com.cd528e70.svg";